<template>
  <download />
</template>

<script>
import download from './views/download.vue'
export default {
  name: 'App',
  components: {
    download
  }
}
</script>
<style lang="less">
@import "@/styles/reset";
@import "@/assets/iconfont/iconfont.css";
</style>
